import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Ursus Victor LLC | Professional Loan Application Support</title>
        <meta name="description" content="Learn about Ursus Victor LLC - your trusted partner for professional loan application and documentation support services." />
      </Helmet>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <h1 style={{fontSize: '3.5rem', fontWeight: '900', marginBottom: '1.5rem'}}>
            About Ursus Victor LLC
          </h1>
          <p style={{fontSize: '1.4rem', opacity: 0.95, lineHeight: '1.7'}}>
            Professional loan application support services dedicated to helping you prepare complete, accurate applications
          </p>
        </div>
      </section>

      {/* Mission */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1.5rem'}}>
              Our Mission
            </h2>
            <p style={{fontSize: '1.3rem', color: '#475569', lineHeight: '1.8', maxWidth: '800px', margin: '0 auto'}}>
              To provide professional, reliable loan application support services that help individuals and businesses 
              prepare complete, accurate loan applications with confidence.
            </p>
          </div>

          <div style={{
            background: '#f8fafc',
            padding: '3rem',
            borderRadius: '16px',
            border: '2px solid #e2e8f0',
            marginTop: '3rem'
          }}>
            <h3 style={{fontSize: '2rem', fontWeight: '800', color: '#1e40af', marginBottom: '1.5rem', textAlign: 'center'}}>
              What We Do
            </h3>
            <p style={{fontSize: '1.15rem', color: '#475569', lineHeight: '1.9', marginBottom: '2rem'}}>
              Ursus Victor LLC specializes in loan application support and documentation services. We help clients navigate 
              the complex loan application process by providing expert guidance on document preparation, application completion, 
              and submission requirements.
            </p>
            <div style={{
              background: '#fef3c7',
              padding: '2rem',
              borderRadius: '12px',
              border: '3px solid #f59e0b'
            }}>
              <p style={{fontSize: '1.1rem', color: '#92400e', fontWeight: '700', margin: 0, textAlign: 'center'}}>
                ⚠️ IMPORTANT: We are a support services company. We do NOT lend money or make lending decisions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section style={{padding: '5rem 2rem', background: '#f8fafc'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Our Approach
            </h2>
            <p style={{fontSize: '1.2rem', color: '#64748b'}}>
              Professional, thorough, and client-focused application support
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2.5rem'
          }}>
            {[
              {
                icon: '🎯',
                title: 'Detail-Oriented',
                desc: 'We meticulously review every document and form to ensure accuracy and completeness'
              },
              {
                icon: '🤝',
                title: 'Client-Centered',
                desc: 'Your needs and goals guide our support process from start to finish'
              },
              {
                icon: '📚',
                title: 'Educational',
                desc: 'We help you understand each step so you feel confident throughout the process'
              },
              {
                icon: '⚡',
                title: 'Efficient',
                desc: 'We work quickly without sacrificing quality or thoroughness'
              },
              {
                icon: '🔒',
                title: 'Confidential',
                desc: 'Your financial information is handled with the highest level of security'
              },
              {
                icon: '💯',
                title: 'Professional',
                desc: 'We maintain the highest standards of professionalism in all our services'
              }
            ].map((item, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2.5rem',
                borderRadius: '16px',
                border: '2px solid #e2e8f0',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1.5rem'}}>{item.icon}</div>
                <h3 style={{fontSize: '1.6rem', fontWeight: '800', color: '#1e40af', marginBottom: '1rem'}}>
                  {item.title}
                </h3>
                <p style={{color: '#64748b', lineHeight: '1.8', fontSize: '1.05rem'}}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Why Choose Ursus Victor LLC?
            </h2>
          </div>

          <div style={{display: 'grid', gap: '2rem'}}>
            {[
              {
                title: 'Specialized Expertise',
                desc: 'We focus exclusively on loan application support, making us experts in this specific field'
              },
              {
                title: 'Comprehensive Support',
                desc: 'From initial consultation to final submission guidance, we support you through every step'
              },
              {
                title: 'No Hidden Agendas',
                desc: 'We are not lenders, so our only goal is to help you prepare the best application possible'
              },
              {
                title: 'Transparent Process',
                desc: 'You always know what we are doing, why we are doing it, and what comes next'
              },
              {
                title: 'Personalized Service',
                desc: 'Every client receives individual attention tailored to their specific situation'
              },
              {
                title: 'Quality Assurance',
                desc: 'Multiple review checkpoints ensure your application is complete and accurate'
              }
            ].map((item, index) => (
              <div key={index} style={{
                background: '#f8fafc',
                padding: '2.5rem',
                borderRadius: '16px',
                border: '2px solid #e2e8f0',
                borderLeft: '6px solid #3b82f6'
              }}>
                <h3 style={{fontSize: '1.7rem', fontWeight: '800', color: '#1e40af', marginBottom: '1rem'}}>
                  {item.title}
                </h3>
                <p style={{color: '#475569', lineHeight: '1.8', fontSize: '1.1rem'}}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Commitment */}
      <section style={{padding: '5rem 2rem', background: '#f8fafc'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1.5rem'}}>
              Our Commitment to You
            </h2>
          </div>

          <div style={{
            background: 'white',
            padding: '3rem',
            borderRadius: '16px',
            border: '2px solid #e2e8f0'
          }}>
            <div style={{display: 'grid', gap: '2rem'}}>
              <div style={{display: 'flex', gap: '1.5rem', alignItems: 'flex-start'}}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>✓</div>
                <div>
                  <h3 style={{fontSize: '1.4rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.5rem'}}>
                    Accuracy First
                  </h3>
                  <p style={{color: '#64748b', lineHeight: '1.7'}}>
                    We ensure every detail in your application is accurate and properly documented
                  </p>
                </div>
              </div>

              <div style={{display: 'flex', gap: '1.5rem', alignItems: 'flex-start'}}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>✓</div>
                <div>
                  <h3 style={{fontSize: '1.4rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.5rem'}}>
                    Clear Communication
                  </h3>
                  <p style={{color: '#64748b', lineHeight: '1.7'}}>
                    We keep you informed at every stage with clear, jargon-free explanations
                  </p>
                </div>
              </div>

              <div style={{display: 'flex', gap: '1.5rem', alignItems: 'flex-start'}}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>✓</div>
                <div>
                  <h3 style={{fontSize: '1.4rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.5rem'}}>
                    Timely Service
                  </h3>
                  <p style={{color: '#64748b', lineHeight: '1.7'}}>
                    We respect your deadlines and work efficiently to meet your timeline
                  </p>
                </div>
              </div>

              <div style={{display: 'flex', gap: '1.5rem', alignItems: 'flex-start'}}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>✓</div>
                <div>
                  <h3 style={{fontSize: '1.4rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.5rem'}}>
                    Confidentiality
                  </h3>
                  <p style={{color: '#64748b', lineHeight: '1.7'}}>
                    Your personal and financial information is protected with strict confidentiality
                  </p>
                </div>
              </div>

              <div style={{display: 'flex', gap: '1.5rem', alignItems: 'flex-start'}}>
                <div style={{fontSize: '2.5rem', flexShrink: 0}}>✓</div>
                <div>
                  <h3 style={{fontSize: '1.4rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.5rem'}}>
                    Ongoing Support
                  </h3>
                  <p style={{color: '#64748b', lineHeight: '1.7'}}>
                    We are available to answer questions even after your application is submitted
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #3b82f6 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h2 style={{fontSize: '2.8rem', fontWeight: '900', marginBottom: '1.5rem'}}>
            Ready to Get Started?
          </h2>
          <p style={{fontSize: '1.3rem', marginBottom: '2.5rem', opacity: 0.95, lineHeight: '1.6'}}>
            Let us help you prepare a professional loan application package
          </p>
          <Link to="/contact" style={{
            background: 'white',
            color: '#1e40af',
            padding: '1.5rem 3.5rem',
            borderRadius: '12px',
            fontWeight: '900',
            fontSize: '1.3rem',
            display: 'inline-block',
            boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
          }}>
            Contact Us Today
          </Link>
        </div>
      </section>

      {/* Disclaimer */}
      <section style={{
        background: '#fef3c7',
        padding: '2.5rem 2rem',
        borderTop: '3px solid #f59e0b'
      }}>
        <div style={{maxWidth: '1000px', margin: '0 auto', textAlign: 'center'}}>
          <p style={{fontSize: '1rem', color: '#92400e', lineHeight: '1.8', fontWeight: '600'}}>
            <strong>IMPORTANT DISCLOSURE:</strong> Ursus Victor LLC provides loan application support and documentation services only. 
            We are NOT a lender, do NOT make loans, and do NOT make lending decisions. We do NOT guarantee loan approval. 
            All lending decisions are made solely by financial institutions.
          </p>
        </div>
      </section>
    </>
  );
};

export default About;
